import { globalConstants } from '_constants';
import { globalService, accountService } from '_services';

const getAccounts = () => async (dispatch, getState) => {
  const { accountID } = getState().entities.auth.me;

  await globalService.getAccounts(accountID || '')
    .then(
      (accounts) => {
        dispatch(success(accounts));
      },
      (error) => {
        dispatch(failure(error.message));
      }
    );

  function success(accounts) { return { type: globalConstants.GLOBAL_ACCOUNT_SUCCESS, accounts }; }
  function failure(error) { return { type: globalConstants.GLOBAL_ACCOUNT_FAILURE, error }; }
};

const setAccount = (accountID) => async (dispatch) => {
  //dispatch({ type: globalConstants.GLOBAL_ACCOUNT_SELECT, account });
  await accountService.getById(accountID)
    .then((fullAccount) => {
      const { accountID, name } = fullAccount;
      dispatch({ type: globalConstants.GLOBAL_ACCOUNT_SELECT, account: { id: accountID, name } });
    });
};

const getTimeZones = () => async (dispatch) => {
  dispatch(request());

  await globalService.getTimeZones()
    .then(
      (timezones) => {
        dispatch(success(timezones));
      },
      (error) => {
        dispatch(failure(error.message));
      }
    );

  function request() { return { type: globalConstants.TIMEZONES_REQUEST }; }
  function success(timezones) { return { type: globalConstants.TIMEZONES_SUCCESS, timezones }; }
  function failure(error) { return { type: globalConstants.TIMEZONES_FAILURE, error }; }
};

const getMachines = (accountID) => async (dispatch) => {
  dispatch(request());

  await globalService.getMachines(accountID)
    .then(
      (machines) => {
        dispatch(success(machines));
      },
      (error) => {
        dispatch(failure(error.message));
      }
    );

  function request() { return { type: globalConstants.GLOBAL_MACHINES_REQUEST }; }
  function success(machines) { return { type: globalConstants.GLOBAL_MACHINES_SUCCESS, machines }; }
  function failure(error) { return { type: globalConstants.GLOBAL_MACHINES_FAILURE, error }; }
};

const globalActions = {
  getAccounts,
  setAccount,
  getTimeZones,
  getMachines,
};

export default globalActions;
